<template>
  <div>
    <div class="cases">
      <v-card elevation="5" v-for="oneCase in allCases" :key="oneCase._id" class="cases_one">
        <v-card-title>
          <h3>{{ oneCase.name }}</h3>
          <v-spacer></v-spacer>
          <!-- <span>{{ oneCase.caseId }}</span> -->
          <v-btn
            icon
            v-if="username === 'gsmsteve@gmail.com'"
            @click="deleteCase(oneCase)"
          >
            <v-icon>delete</v-icon>
          </v-btn>
          <v-btn
            icon
            v-if="username === 'gsmsteve@gmail.com'"
            @click="editCase(oneCase)"
          >
            <v-icon>edit</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-5" style="font-size: 16px;">
          Case:
          <span>{{ oneCase.caseId }}</span>
          <br />
          Name:
          <span>{{ oneCase.name }}</span>
        </v-card-text>
        <v-card-actions class="justify-center">
          <!-- <router-link :to="dashboard">Open</router-link> -->
          <v-btn
            large
            class="info"
            @click.native="studyCase(oneCase.caseId)"
          >
            Open
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <v-dialog
      :title="form._id ? 'Update case' : 'New case'"
      max-width="500"
      v-model="formVisible"
    >
      <v-card ref="case" class="editdialog pb-5">
        <v-toolbar class="primary white--text">
          <h3>Edit case</h3>
        </v-toolbar>
        <v-card-text class="pt-3">
          <v-text-field disabled label="Case Id" v-model="form.caseId" />
          <v-text-field label="Name" v-model="form.name" />
          <v-text-field label="Age" v-model="form.age" />
          <v-text-field label="Sex" v-model="form.sex" />
          <v-text-field label="Encounters" v-model="form.encounters" />
          <v-text-field label="Prognosis" v-model="form.prognosis" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.native="cancelForm">Cancel</v-btn>
          <v-btn text color="primary" @click.native="saveForm">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm-dialog ref="confirm" />
  </div>
</template>
<script>
// import { acase as caseRes } from 'resources'
import { mapGetters, mapActions } from 'vuex'
import ConfirmDialog from '../Common/ConfirmDialog.vue'
export default {
  components: {
    ConfirmDialog
  },
  data () {
    return {
      formVisible: false,
      form: {
        _id: '',
        caseId: '',
        name: '',
        age: 0,
        sex: '',
        encounters: '',
        prognosis: ''
      },
      // username: '',
      rules: {
        name: [{ required: true, message: 'Name is required', trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapGetters(['allCases']),
    ...mapActions(['getCaseList']),
    username: function () {
      return this.$store.state.auth.username
    }
  },
  methods: {
    fetch () {
      // TODO: ask vuex to fetch case from backend.
      this.$store.dispatch('getCaseList')
      this.$store.dispatch('getPatientList')
    },
    createCase () {
      this.formVisible = true
    },
    studyCase (caseId) {
      this.$store.dispatch('setCaseId', caseId)
      this.$router.push({
        path: `/case/${caseId}`
      })
    },
    cancelForm () {
      this.form.caseId = ''
      this.form.name = ''
      this.form.age = ''
      this.form.sex = ''
      this.form.prognosis = ''
      this.form.encounters = ''
      this.formVisible = false
    },
    saveForm () {
      this.$refs.case.validate(valid => {
        if (valid) {
          let promise
          // TODO:
          // if (this.form._id) {
          //   promise = caseRes.update({ _id: this.form._id }, this.form)
          // } else {
          //   promise = caseRes.save({}, {
          //     caseId: this.form.caseId,
          //     name: this.form.name,
          //     age: this.form.age,
          //     sex: this.form.sex,
          //     encounters: this.form.encounters,
          //     prognosis: this.form.prognosis
          //   })
          // }
          promise
            .then(() => {
              this.cancelForm()
              this.$message({
                type: 'success',
                message: this.form._id ? 'Case updated.' : 'Case created.'
              })
              this.fetch()
            })
            .catch(() => {})
        }
      })
    },
    editCase (theCase) {
      Object.assign(this.form, theCase)
      this.formVisible = true
    },
    async deleteCase (theCase) {
      if (
        await this.$refs.confirm.open(
          'Delete case',
          'Are you sure you want to delete the case?',
          {
            color: 'error'
          }
        )
      ) {
        this.doCaseDelete()
      }
      // this.$confirm(`This action will remove the selected case: ${theCase.name} forever, still going on?`, 'Delete', {
      //   type: 'warning'
      // }).then(() => {
      // TODO: delete case.
      // caseRes.delete({ _id: theCase._id }).then(() => {
      //   this.$message({
      //     type: 'success',
      //     message: 'Case removed.'
      //   })
      //   this.fetch()
      // })
      // }).catch(() => {})
    },
    doCaseDelete () {
      // todo: delete case.
    }
  },
  created () {
    this.fetch()
  }
}
</script>
<style lang="css" scoped>
.cases {
  display: flex;
  justify-content: center;
  flex: 0 0 100%;
  flex-wrap: wrap;
}
.cases > div {
  margin: 1.5%;
}
.cases_one {
  width: 28%;
  margin: 20px;
  padding-bottom: 20px;
}
.info {
  width: 40%;
}
.editdialog {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Case/CaseList.vue